module.exports = __webpack_public_path__ + "static/media/logob.ebb03257.jpg";